import { SamplePackForm } from '../../internal/sample-packs/SamplePackForm'

export const CreateSamplePack = () => {
  return <SamplePackForm />
}
